import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller, useFormContext, RegisterOptions } from 'react-hook-form';

export type FormTextFieldProps = Omit<TextFieldProps, 'name'> & {
  name: string;
  rules?: RegisterOptions;
};

export const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  label,
  rules,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={label}
          error={!!error}
          helperText={error?.message}
          {...rest}
        />
      )}
    />
  );
};
